import React from 'react';
import { Card } from 'react-bootstrap';
 
const ModificationInstruction = (props) => {
  // without the check, value access can fail because the data is loaded asynchronously
  if (props.short_instruction && props.short_instruction.short && props.short_instruction.short.task_desc) {
    const short_instruction = props.short_instruction.short.task_desc
    // console.log("instruction:", instruction)
    console.log("task:", props.task)
    return (
      <div className="mb-20 mt-50">
          <h2>Text Modification Description</h2>
          <Card>
              <Card.Body>
                  <Card.Text>    
                      { props.short_instruction.short.task_desc.map(
                          (line, index) => (<p key={index}>{line}</p>)
                      )}

                      {/* Negate the text by making minimal modifications to introduce <b>lexical negation</b>. <br/>
                      Lexical negation: when the negation is added by substituting the main predicate of the sentence with its antonym or word carrying negative meaning.<br/>
                      <b>Example</b> <br/>
                      The house is big. &rarr;  The house is small. */}
                  </Card.Text>
              </Card.Body>
          </Card>
      </div>
    );
  } else {
    return <div></div>
  }
};

export default ModificationInstruction;
